import React from 'react';
export function PainSection() {
  const painPoints = [{
    icon: '🔄',
    text: 'Caíste de nuevo en lo que prometiste no hacer — y lo peor no fue el acto, sino la culpa que vino después.'
  }, {
    icon: '😶',
    text: 'Eres funcional, "tienes todo bajo control" — pero hay algo que jala en otra dirección y que no puedes explicarle a nadie.'
  }, {
    icon: '💪',
    text: 'Probaste fuerza de voluntad, apps, libros, promesas contigo mismo/a. Funcionó por un tiempo. El ciclo volvió.'
  }, {
    icon: '🪤',
    text: 'Sientes que cuanto más tiempo llevas en esto, más difícil se hace creer que algo puede ser diferente.'
  }, {
    icon: '😔',
    text: 'La culpa que sientes después no te protege de la próxima recaída. Te prepara para ella.'
  }];
  return <section className="py-10 md:py-14 px-5 bg-[radial-gradient(ellipse_at_top_right,rgba(194,0,111,0.15)_0%,transparent_60%),var(--dark-bg)]" data-id="element-172">
      <div className="max-w-[900px] mx-auto" data-id="element-173">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-4" data-id="element-174">
          ¿Te identificas?
        </span>

        <h2 className="text-[clamp(1.8rem,4vw,2.8rem)] font-heading font-black leading-[1.2] mb-5" data-id="element-175">
          ¿Cuántas veces dijiste
          <br data-id="element-176" />
          <span className="text-gradient-magenta" data-id="element-177">"nunca más"</span> —<br data-id="element-178" />y
          volviste a caer igual?
        </h2>

        <ul className="list-none mt-5 mb-4 space-y-3" data-id="element-179">
          {painPoints.map((point, idx) => <li key={idx} className="flex items-start gap-4 py-[18px] px-6 bg-[rgba(194,0,111,0.08)] border border-[rgba(194,0,111,0.2)] border-l-4 border-l-magenta rounded-[10px] text-[1rem] leading-[1.6] text-white/85 transition-all duration-300 hover:bg-[rgba(194,0,111,0.15)] hover:border-l-magenta-bright hover:translate-x-[5px]" data-id="element-180">
              <span className="text-[1.4rem] shrink-0 mt-[2px]" data-id="element-181">
                {point.icon}
              </span>
              <span data-id="element-182">{point.text}</span>
            </li>)}
        </ul>

        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.3)] to-[rgba(194,0,111,0.2)] border border-[rgba(194,0,111,0.4)] rounded-2xl py-6 px-7 mt-5 text-center" data-id="element-183">
          <blockquote className="font-heading font-bold text-[clamp(1.1rem,2.5vw,1.5rem)] leading-[1.5] text-white" data-id="element-184">
            "El ciclo no persiste porque seas débil.
            <br data-id="element-185" />
            Persiste porque{' '}
            <em className="text-magenta-bright not-italic" data-id="element-186">
              nadie te dio las herramientas para interrumpirlo.
            </em>
            "
          </blockquote>
        </div>

        {/* Customer Reviews */}
        <div className="mt-8" data-id="element-187">
          <h3 className="font-heading font-bold text-[1rem] tracking-[2px] uppercase text-white/50 mb-5 text-center" data-id="element-188">
            Lo que dicen quienes ya lo tienen
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-189">
            {/* Review 1 - Camila - 5 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-190">
              <div className="flex items-center gap-2 mb-2" data-id="element-191">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-192">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-193">
                "Lo leí en una noche. Por primera vez entendí por qué me pasaba
                lo que me pasaba. Lloré, pero de alivio."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-194">
                — Camila R.
              </p>
            </div>

            {/* Review 2 - Martín - 4 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-195">
              <div className="flex items-center gap-2 mb-2" data-id="element-196">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-197">
                  ★★★★<span className="text-white/20" data-id="element-198">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-199">
                "Pensé que era otro libro de autoayuda genérico. Me equivoqué.
                Es directo, sin rodeos y funciona."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-200">
                — Martín L.
              </p>
            </div>

            {/* Review 3 - Diego - 5 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-201">
              <div className="flex items-center gap-2 mb-2" data-id="element-202">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-203">
                  ★★★★★
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-204">
                "Llevo 3 semanas aplicando el método y la diferencia es real.
                Ojalá lo hubiera encontrado antes."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-205">
                — Diego M.
              </p>
            </div>

            {/* Review 4 - Valentina - 4 stars */}
            <div className="bg-card-bg border border-white/10 rounded-xl p-5 text-left transition-all duration-300 hover:border-magenta/30" data-id="element-206">
              <div className="flex items-center gap-2 mb-2" data-id="element-207">
                <span className="text-gold text-[1rem] tracking-wide" data-id="element-208">
                  ★★★★<span className="text-white/20" data-id="element-209">★</span>
                </span>
              </div>
              <p className="text-white/80 text-[0.9rem] leading-relaxed mb-3" data-id="element-210">
                "Me dio herramientas concretas, no frases vacías. Lo recomiendo
                a cualquiera que sienta que no puede solo/a."
              </p>
              <p className="font-heading font-bold text-[0.85rem] text-white/60" data-id="element-211">
                — Valentina S.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}